module.exports = function() {
  return new Worker(__webpack_public_path__ + "d4079a3d1a51eee33351.worker.js");
};